// Enhanced RBAC System - More Granular and Manageable
// This will replace the existing rbac.ts file
export var RoleLevel;
(function (RoleLevel) {
    RoleLevel[RoleLevel["SUSPENDED"] = 1] = "SUSPENDED";
    RoleLevel[RoleLevel["GUEST"] = 2] = "GUEST";
    RoleLevel[RoleLevel["DEALER_APPLICANT"] = 3] = "DEALER_APPLICANT";
    RoleLevel[RoleLevel["BASIC_DEALER"] = 4] = "BASIC_DEALER";
    RoleLevel[RoleLevel["VERIFIED_DEALER"] = 5] = "VERIFIED_DEALER";
    RoleLevel[RoleLevel["SENIOR_DEALER"] = 6] = "SENIOR_DEALER";
    RoleLevel[RoleLevel["SALES_MANAGER"] = 7] = "SALES_MANAGER";
    RoleLevel[RoleLevel["REGION_ADMIN"] = 8] = "REGION_ADMIN";
    RoleLevel[RoleLevel["PLATFORM_ADMIN"] = 9] = "PLATFORM_ADMIN";
    RoleLevel[RoleLevel["SUPER_ADMIN"] = 10] = "SUPER_ADMIN";
})(RoleLevel || (RoleLevel = {}));
// Human-readable role labels for UI display
export const ROLE_LABELS = {
    [RoleLevel.SUSPENDED]: 'Suspended',
    [RoleLevel.GUEST]: 'Guest User',
    [RoleLevel.DEALER_APPLICANT]: 'Dealer Applicant',
    [RoleLevel.BASIC_DEALER]: 'Basic Dealer',
    [RoleLevel.VERIFIED_DEALER]: 'Verified Dealer',
    [RoleLevel.SENIOR_DEALER]: 'Senior Dealer',
    [RoleLevel.SALES_MANAGER]: 'Sales Manager',
    [RoleLevel.REGION_ADMIN]: 'Region Admin',
    [RoleLevel.PLATFORM_ADMIN]: 'Platform Admin',
    [RoleLevel.SUPER_ADMIN]: 'Super Admin'
};
// Hierarchical Permission System - Each permission has clear scope and granularity
export var PagePermissions;
(function (PagePermissions) {
    // Public Pages
    PagePermissions["VIEW_HOME"] = "page.home.view";
    PagePermissions["VIEW_WELCOME"] = "page.welcome.view";
    PagePermissions["VIEW_CONTACT"] = "page.contact.view";
    // Authentication Pages
    PagePermissions["VIEW_LOGIN"] = "page.login.view";
    PagePermissions["VIEW_REGISTER"] = "page.register.view";
    // Platform Access
    PagePermissions["VIEW_ROYAL_GEMS_PLATFORM"] = "page.platform.view";
    // Dealer Dashboard & Profile
    PagePermissions["VIEW_DEALER_DASHBOARD"] = "page.dealer.dashboard.view";
    PagePermissions["VIEW_DEALER_PROFILE"] = "page.dealer.profile.view";
    PagePermissions["EDIT_DEALER_PROFILE"] = "page.dealer.profile.edit";
    PagePermissions["VIEW_DEALER_SETTINGS"] = "page.dealer.settings.view";
    // Atelier & Inventory
    PagePermissions["VIEW_ATELIER"] = "page.atelier.view";
    PagePermissions["VIEW_INVENTORY_SEARCH"] = "page.inventory.search.view";
    PagePermissions["VIEW_INVENTORY_BROWSE"] = "page.inventory.browse.view";
    PagePermissions["VIEW_INVENTORY_DETAILS"] = "page.inventory.details.view";
    // Orders & Transactions
    PagePermissions["VIEW_ORDERS"] = "page.orders.view";
    PagePermissions["VIEW_ORDER_HISTORY"] = "page.orders.history.view";
    PagePermissions["VIEW_ORDER_DETAILS"] = "page.orders.details.view";
    PagePermissions["CREATE_ORDER"] = "page.orders.create";
    // Memo System
    PagePermissions["VIEW_MEMO_REQUESTS"] = "page.memo.requests.view";
    PagePermissions["VIEW_MEMO_HISTORY"] = "page.memo.history.view";
    PagePermissions["MANAGE_MEMO_REQUESTS"] = "page.memo.requests.manage";
    // Admin Pages
    PagePermissions["VIEW_ADMIN_DASHBOARD"] = "page.admin.dashboard.view";
    PagePermissions["VIEW_USER_MANAGEMENT"] = "page.admin.users.view";
    PagePermissions["VIEW_INVENTORY_MANAGEMENT"] = "page.admin.inventory.view";
    PagePermissions["VIEW_ANALYTICS"] = "page.admin.analytics.view";
    PagePermissions["VIEW_SYSTEM_SETTINGS"] = "page.admin.settings.view";
    PagePermissions["VIEW_PERMISSION_MANAGEMENT"] = "page.admin.permissions.view";
    PagePermissions["VIEW_AUDIT_LOGS"] = "page.admin.audit.view";
    // Auction House
    PagePermissions["VIEW_AUCTION_HOUSE"] = "page.auction.house.view";
    PagePermissions["VIEW_AUCTION_DETAIL"] = "page.auction.detail.view";
    PagePermissions["VIEW_AUCTION_ADMIN"] = "page.auction.admin.view";
})(PagePermissions || (PagePermissions = {}));
export var ComponentPermissions;
(function (ComponentPermissions) {
    // Navigation Components
    ComponentPermissions["SHOW_DEALER_MENU"] = "component.navigation.dealer_menu";
    ComponentPermissions["SHOW_ADMIN_MENU"] = "component.navigation.admin_menu";
    ComponentPermissions["SHOW_SUPER_ADMIN_MENU"] = "component.navigation.super_admin_menu";
    // Search Components
    ComponentPermissions["USE_BASIC_SEARCH"] = "component.search.basic";
    ComponentPermissions["USE_ADVANCED_SEARCH"] = "component.search.advanced";
    ComponentPermissions["USE_AI_POWERED_SEARCH"] = "component.search.ai_powered";
    ComponentPermissions["USE_SAVED_SEARCHES"] = "component.search.saved_searches";
    // Inventory Display Components
    ComponentPermissions["VIEW_BASIC_INVENTORY"] = "component.inventory.basic.view";
    ComponentPermissions["VIEW_PREMIUM_INVENTORY"] = "component.inventory.premium.view";
    ComponentPermissions["VIEW_EXCLUSIVE_INVENTORY"] = "component.inventory.exclusive.view";
    ComponentPermissions["VIEW_DIAMOND_PRICES"] = "component.inventory.prices.view";
    ComponentPermissions["VIEW_WHOLESALE_PRICES"] = "component.inventory.wholesale_prices.view";
    ComponentPermissions["VIEW_DEALER_PRICES"] = "component.inventory.dealer_prices.view";
    // Export Components
    ComponentPermissions["EXPORT_SEARCH_RESULTS"] = "component.export.search_results";
    ComponentPermissions["EXPORT_INVENTORY_LIST"] = "component.export.inventory_list";
    ComponentPermissions["EXPORT_ORDER_DATA"] = "component.export.order_data";
    ComponentPermissions["EXPORT_USER_DATA"] = "component.export.user_data";
    // Memo Components
    ComponentPermissions["REQUEST_MEMO_COMPONENT"] = "component.memo.request";
    ComponentPermissions["APPROVE_MEMO_COMPONENT"] = "component.memo.approve";
    ComponentPermissions["VIEW_MEMO_STATUS"] = "component.memo.status.view";
    ComponentPermissions["MANAGE_MEMO_LIMITS"] = "component.memo.limits.manage";
    // User Management Components
    ComponentPermissions["VIEW_USER_LIST"] = "component.users.list.view";
    ComponentPermissions["VIEW_USER_DETAILS"] = "component.users.details.view";
    ComponentPermissions["EDIT_USER_ROLES"] = "component.users.roles.edit";
    ComponentPermissions["EDIT_USER_PERMISSIONS"] = "component.users.permissions.edit";
    ComponentPermissions["VIEW_USER_AUDIT_LOG"] = "component.users.audit.view";
    // Inventory Management Components
    ComponentPermissions["ADD_DIAMONDS"] = "component.inventory.diamonds.add";
    ComponentPermissions["EDIT_DIAMONDS"] = "component.inventory.diamonds.edit";
    ComponentPermissions["DELETE_DIAMONDS"] = "component.inventory.diamonds.delete";
    ComponentPermissions["MANAGE_PRICING"] = "component.inventory.pricing.manage";
    ComponentPermissions["BULK_UPDATE_INVENTORY"] = "component.inventory.bulk_update";
    // Analytics Components
    ComponentPermissions["VIEW_SALES_ANALYTICS"] = "component.analytics.sales.view";
    ComponentPermissions["VIEW_USER_ANALYTICS"] = "component.analytics.users.view";
    ComponentPermissions["VIEW_INVENTORY_ANALYTICS"] = "component.analytics.inventory.view";
    ComponentPermissions["VIEW_FINANCIAL_REPORTS"] = "component.analytics.financial.view";
    // System Components
    ComponentPermissions["SYSTEM_CONFIGURATION"] = "component.system.config";
    ComponentPermissions["MANAGE_INTEGRATIONS"] = "component.system.integrations";
    ComponentPermissions["VIEW_SYSTEM_LOGS"] = "component.system.logs.view";
    // Auction House
    ComponentPermissions["VIEW_ACTIVE_AUCTIONS"] = "component.auction.active.view";
    ComponentPermissions["VIEW_AUCTION_HISTORY"] = "component.auction.history.view";
    ComponentPermissions["PLACE_AUCTION_BID"] = "component.auction.bid.place";
    ComponentPermissions["CREATE_AUCTION_COMPONENT"] = "component.auction.create";
    ComponentPermissions["MANAGE_AUCTION"] = "component.auction.manage";
    ComponentPermissions["VIEW_AUCTION_ANALYTICS"] = "component.auction.analytics.view";
})(ComponentPermissions || (ComponentPermissions = {}));
export var ActionPermissions;
(function (ActionPermissions) {
    // Authentication Actions
    ActionPermissions["LOGIN"] = "action.auth.login";
    ActionPermissions["LOGOUT"] = "action.auth.logout";
    ActionPermissions["REGISTER"] = "action.auth.register";
    ActionPermissions["RESET_PASSWORD"] = "action.auth.password_reset";
    // Profile Actions
    ActionPermissions["UPDATE_PROFILE"] = "action.user.profile.update";
    ActionPermissions["CHANGE_PASSWORD"] = "action.user.password.change";
    ActionPermissions["ENABLE_MFA"] = "action.user.mfa.enable";
    ActionPermissions["DISABLE_MFA"] = "action.user.mfa.disable";
    ActionPermissions["UPDATE_PREFERENCES"] = "action.user.preferences.update";
    // Diamond & Inventory Actions
    ActionPermissions["VIEW_DIAMOND_DETAILS"] = "action.diamond.details.view";
    ActionPermissions["VIEW_DIAMOND_CERTIFICATE"] = "action.diamond.certificate.view";
    ActionPermissions["DOWNLOAD_DIAMOND_IMAGES"] = "action.diamond.images.download";
    // Transaction Actions
    ActionPermissions["REQUEST_DIAMOND_MEMO"] = "action.transaction.memo.request";
    ActionPermissions["APPROVE_MEMO_REQUEST"] = "action.transaction.memo.approve";
    ActionPermissions["REJECT_MEMO_REQUEST"] = "action.transaction.memo.reject";
    ActionPermissions["PURCHASE_DIAMOND"] = "action.transaction.purchase";
    ActionPermissions["RESERVE_DIAMOND"] = "action.transaction.reserve";
    ActionPermissions["CANCEL_RESERVATION"] = "action.transaction.reservation.cancel";
    // Order Management Actions
    ActionPermissions["CREATE_ORDER"] = "action.order.create";
    ActionPermissions["MODIFY_ORDER"] = "action.order.modify";
    ActionPermissions["CANCEL_ORDER"] = "action.order.cancel";
    ActionPermissions["APPROVE_ORDER"] = "action.order.approve";
    ActionPermissions["FULFILL_ORDER"] = "action.order.fulfill";
    ActionPermissions["PROCESS_PAYMENT"] = "action.order.payment.process";
    // Data Export Actions
    ActionPermissions["EXPORT_SEARCH_RESULTS"] = "action.export.search_results";
    ActionPermissions["EXPORT_ORDER_HISTORY"] = "action.export.order_history";
    ActionPermissions["EXPORT_MEMO_HISTORY"] = "action.export.memo_history";
    ActionPermissions["EXPORT_USER_DATA"] = "action.export.user_data";
    ActionPermissions["EXPORT_ANALYTICS"] = "action.export.analytics";
    // Admin Actions - User Management
    ActionPermissions["CREATE_USER"] = "action.admin.user.create";
    ActionPermissions["EDIT_USER"] = "action.admin.user.edit";
    ActionPermissions["DELETE_USER"] = "action.admin.user.delete";
    ActionPermissions["UPDATE_USER_ROLE"] = "action.admin.user.role.update";
    ActionPermissions["UPDATE_USER_STATUS"] = "action.admin.user.status.update";
    ActionPermissions["RESET_USER_PASSWORD"] = "action.admin.user.password.reset";
    ActionPermissions["UNLOCK_USER_ACCOUNT"] = "action.admin.user.account.unlock";
    // Admin Actions - Permission Management
    ActionPermissions["VIEW_USER_PERMISSIONS"] = "action.admin.permissions.user.view";
    ActionPermissions["EDIT_USER_PERMISSIONS"] = "action.admin.permissions.user.edit";
    ActionPermissions["CREATE_PERMISSION_TEMPLATE"] = "action.admin.permissions.template.create";
    ActionPermissions["MANAGE_ROLE_PERMISSIONS"] = "action.admin.permissions.role.manage";
    ActionPermissions["AUDIT_PERMISSION_CHANGES"] = "action.admin.permissions.audit.view";
    // Admin Actions - Inventory Management
    ActionPermissions["ADD_INVENTORY"] = "action.admin.inventory.add";
    ActionPermissions["EDIT_INVENTORY"] = "action.admin.inventory.edit";
    ActionPermissions["DELETE_INVENTORY"] = "action.admin.inventory.delete";
    ActionPermissions["BULK_UPDATE_INVENTORY"] = "action.admin.inventory.bulk_update";
    ActionPermissions["UPDATE_PRICING"] = "action.admin.inventory.pricing.update";
    ActionPermissions["MANAGE_INVENTORY_CATEGORIES"] = "action.admin.inventory.categories.manage";
    // Admin Actions - System
    ActionPermissions["SYSTEM_CONFIGURATION"] = "action.admin.system.configure";
    ActionPermissions["MANAGE_INTEGRATIONS"] = "action.admin.system.integrations.manage";
    ActionPermissions["VIEW_SYSTEM_LOGS"] = "action.admin.system.logs.view";
    ActionPermissions["BACKUP_SYSTEM"] = "action.admin.system.backup";
    ActionPermissions["RESTORE_SYSTEM"] = "action.admin.system.restore";
    // Auction House Actions
    ActionPermissions["CREATE_AUCTION"] = "action.auction.create";
    ActionPermissions["EDIT_AUCTION"] = "action.auction.edit";
    ActionPermissions["CANCEL_AUCTION"] = "action.auction.cancel";
    ActionPermissions["PLACE_BID"] = "action.auction.bid.place";
    ActionPermissions["SUPERVISED_AUCTION_CONTROL"] = "action.auction.supervised.control";
    ActionPermissions["CLOSE_AUCTION"] = "action.auction.close";
    ActionPermissions["INVITE_TO_AUCTION"] = "action.auction.invite";
    // Super Admin Actions
    ActionPermissions["MANAGE_ADMIN_USERS"] = "action.super_admin.users.manage";
    ActionPermissions["CONFIGURE_ROLES"] = "action.super_admin.roles.configure";
    ActionPermissions["SYSTEM_MAINTENANCE"] = "action.super_admin.system.maintenance";
    ActionPermissions["ACCESS_RAW_DATABASE"] = "action.super_admin.database.raw_access";
    ActionPermissions["EMERGENCY_OVERRIDE"] = "action.super_admin.emergency.override";
})(ActionPermissions || (ActionPermissions = {}));
// Enhanced Role-Permission Mapping with proper inheritance
export const ENHANCED_ROLE_PERMISSIONS = {
    [RoleLevel.SUSPENDED]: [],
    [RoleLevel.GUEST]: [
        // Public access only
        PagePermissions.VIEW_HOME,
        PagePermissions.VIEW_WELCOME,
        PagePermissions.VIEW_CONTACT,
        PagePermissions.VIEW_LOGIN,
        PagePermissions.VIEW_REGISTER,
        PagePermissions.VIEW_ROYAL_GEMS_PLATFORM,
        ActionPermissions.LOGIN,
        ActionPermissions.REGISTER,
    ],
    [RoleLevel.DEALER_APPLICANT]: [
        // Basic profile management after registration
        ActionPermissions.UPDATE_PROFILE,
        ActionPermissions.CHANGE_PASSWORD,
        ActionPermissions.ENABLE_MFA,
        ActionPermissions.UPDATE_PREFERENCES,
        // Platform viewing (with request access overlays)
        PagePermissions.VIEW_ROYAL_GEMS_PLATFORM,
        PagePermissions.VIEW_ATELIER, // Allow access to atelier page
    ],
    [RoleLevel.BASIC_DEALER]: [
        // Basic dealer functionality
        PagePermissions.VIEW_DEALER_DASHBOARD,
        PagePermissions.VIEW_DEALER_PROFILE,
        PagePermissions.EDIT_DEALER_PROFILE,
        PagePermissions.VIEW_ATELIER,
        PagePermissions.VIEW_INVENTORY_SEARCH,
        PagePermissions.VIEW_MEMO_REQUESTS, // View own memo requests on /memos page
        ComponentPermissions.SHOW_DEALER_MENU,
        ComponentPermissions.USE_BASIC_SEARCH,
        ComponentPermissions.VIEW_BASIC_INVENTORY,
        ComponentPermissions.VIEW_DIAMOND_PRICES,
        ComponentPermissions.REQUEST_MEMO_COMPONENT,
        ComponentPermissions.VIEW_MEMO_STATUS,
        ActionPermissions.VIEW_DIAMOND_DETAILS,
        ActionPermissions.VIEW_DIAMOND_CERTIFICATE,
        ActionPermissions.REQUEST_DIAMOND_MEMO,
        ActionPermissions.CREATE_ORDER,
    ],
    [RoleLevel.VERIFIED_DEALER]: [
        // Enhanced dealer capabilities
        PagePermissions.VIEW_INVENTORY_BROWSE,
        PagePermissions.VIEW_INVENTORY_DETAILS,
        PagePermissions.VIEW_ORDERS,
        PagePermissions.VIEW_ORDER_HISTORY,
        PagePermissions.VIEW_ORDER_DETAILS,
        ComponentPermissions.USE_ADVANCED_SEARCH,
        ComponentPermissions.VIEW_PREMIUM_INVENTORY,
        ActionPermissions.RESERVE_DIAMOND,
        ActionPermissions.CANCEL_RESERVATION,
        ActionPermissions.MODIFY_ORDER,
        ActionPermissions.CANCEL_ORDER,
        ActionPermissions.EXPORT_SEARCH_RESULTS,
    ],
    [RoleLevel.SENIOR_DEALER]: [
        // Advanced dealer features
        PagePermissions.VIEW_MEMO_REQUESTS,
        PagePermissions.VIEW_MEMO_HISTORY,
        ComponentPermissions.VIEW_EXCLUSIVE_INVENTORY,
        ComponentPermissions.VIEW_WHOLESALE_PRICES,
        ComponentPermissions.USE_AI_POWERED_SEARCH,
        ComponentPermissions.USE_SAVED_SEARCHES,
        ComponentPermissions.EXPORT_SEARCH_RESULTS,
        ComponentPermissions.EXPORT_INVENTORY_LIST,
        ActionPermissions.PURCHASE_DIAMOND,
        ActionPermissions.DOWNLOAD_DIAMOND_IMAGES,
        ActionPermissions.EXPORT_ORDER_HISTORY,
        ActionPermissions.EXPORT_MEMO_HISTORY,
    ],
    [RoleLevel.SALES_MANAGER]: [
        // Management capabilities
        PagePermissions.VIEW_ADMIN_DASHBOARD,
        PagePermissions.VIEW_ANALYTICS,
        ComponentPermissions.SHOW_ADMIN_MENU,
        ComponentPermissions.APPROVE_MEMO_COMPONENT,
        ComponentPermissions.VIEW_USER_LIST,
        ComponentPermissions.VIEW_SALES_ANALYTICS,
        ComponentPermissions.VIEW_USER_ANALYTICS,
        ActionPermissions.APPROVE_MEMO_REQUEST,
        ActionPermissions.REJECT_MEMO_REQUEST,
        ActionPermissions.APPROVE_ORDER,
        ActionPermissions.VIEW_USER_PERMISSIONS,
        ActionPermissions.EXPORT_ANALYTICS,
    ],
    [RoleLevel.REGION_ADMIN]: [
        // Regional administration
        PagePermissions.VIEW_USER_MANAGEMENT,
        PagePermissions.VIEW_INVENTORY_MANAGEMENT,
        ComponentPermissions.VIEW_USER_DETAILS,
        ComponentPermissions.EDIT_USER_ROLES,
        ComponentPermissions.ADD_DIAMONDS,
        ComponentPermissions.EDIT_DIAMONDS,
        ComponentPermissions.MANAGE_PRICING,
        ComponentPermissions.VIEW_INVENTORY_ANALYTICS,
        ActionPermissions.CREATE_USER,
        ActionPermissions.EDIT_USER,
        ActionPermissions.UPDATE_USER_ROLE,
        ActionPermissions.UPDATE_USER_STATUS,
        ActionPermissions.ADD_INVENTORY,
        ActionPermissions.EDIT_INVENTORY,
        ActionPermissions.UPDATE_PRICING,
        ActionPermissions.EXPORT_USER_DATA,
    ],
    [RoleLevel.PLATFORM_ADMIN]: [
        // Platform-wide administration
        PagePermissions.VIEW_SYSTEM_SETTINGS,
        PagePermissions.VIEW_AUDIT_LOGS,
        ComponentPermissions.EDIT_USER_PERMISSIONS,
        ComponentPermissions.DELETE_DIAMONDS,
        ComponentPermissions.BULK_UPDATE_INVENTORY,
        ComponentPermissions.SYSTEM_CONFIGURATION,
        ComponentPermissions.VIEW_SYSTEM_LOGS,
        ActionPermissions.DELETE_USER,
        ActionPermissions.RESET_USER_PASSWORD,
        ActionPermissions.UNLOCK_USER_ACCOUNT,
        ActionPermissions.EDIT_USER_PERMISSIONS,
        ActionPermissions.DELETE_INVENTORY,
        ActionPermissions.BULK_UPDATE_INVENTORY,
        ActionPermissions.SYSTEM_CONFIGURATION,
        ActionPermissions.VIEW_SYSTEM_LOGS,
    ],
    [RoleLevel.SUPER_ADMIN]: [
        // Complete system access
        PagePermissions.VIEW_PERMISSION_MANAGEMENT,
        ComponentPermissions.VIEW_USER_AUDIT_LOG,
        ComponentPermissions.MANAGE_INTEGRATIONS,
        ComponentPermissions.VIEW_FINANCIAL_REPORTS,
        ActionPermissions.MANAGE_ADMIN_USERS,
        ActionPermissions.CONFIGURE_ROLES,
        ActionPermissions.CREATE_PERMISSION_TEMPLATE,
        ActionPermissions.MANAGE_ROLE_PERMISSIONS,
        ActionPermissions.AUDIT_PERMISSION_CHANGES,
        ActionPermissions.SYSTEM_MAINTENANCE,
        ActionPermissions.BACKUP_SYSTEM,
        ActionPermissions.RESTORE_SYSTEM,
        ActionPermissions.ACCESS_RAW_DATABASE,
        ActionPermissions.EMERGENCY_OVERRIDE,
        // Auction House - Super Admin only
        PagePermissions.VIEW_AUCTION_HOUSE,
        PagePermissions.VIEW_AUCTION_DETAIL,
        PagePermissions.VIEW_AUCTION_ADMIN,
        ComponentPermissions.VIEW_ACTIVE_AUCTIONS,
        ComponentPermissions.PLACE_AUCTION_BID,
        ComponentPermissions.VIEW_AUCTION_HISTORY,
        ComponentPermissions.VIEW_AUCTION_ANALYTICS,
        ComponentPermissions.CREATE_AUCTION_COMPONENT,
        ComponentPermissions.MANAGE_AUCTION,
        ActionPermissions.CREATE_AUCTION,
        ActionPermissions.EDIT_AUCTION,
        ActionPermissions.CANCEL_AUCTION,
        ActionPermissions.PLACE_BID,
        ActionPermissions.SUPERVISED_AUCTION_CONTROL,
        ActionPermissions.CLOSE_AUCTION,
        ActionPermissions.INVITE_TO_AUCTION,
    ]
};
// Build complete permission inheritance
export const buildRolePermissions = () => {
    const rolePermissions = {
        [RoleLevel.SUSPENDED]: [],
        [RoleLevel.GUEST]: [],
        [RoleLevel.DEALER_APPLICANT]: [],
        [RoleLevel.BASIC_DEALER]: [],
        [RoleLevel.VERIFIED_DEALER]: [],
        [RoleLevel.SENIOR_DEALER]: [],
        [RoleLevel.SALES_MANAGER]: [],
        [RoleLevel.REGION_ADMIN]: [],
        [RoleLevel.PLATFORM_ADMIN]: [],
        [RoleLevel.SUPER_ADMIN]: [],
    };
    // Build inheritance chain
    for (let level = RoleLevel.GUEST; level <= RoleLevel.SUPER_ADMIN; level++) {
        const permissions = [];
        // Add permissions from all lower levels
        for (let inheritLevel = RoleLevel.GUEST; inheritLevel <= level; inheritLevel++) {
            if (ENHANCED_ROLE_PERMISSIONS[inheritLevel]) {
                permissions.push(...ENHANCED_ROLE_PERMISSIONS[inheritLevel]);
            }
        }
        rolePermissions[level] = [...new Set(permissions)];
    }
    return rolePermissions;
};
// Permission categories for easier management
export const PERMISSION_CATEGORIES = {
    'Page Access': Object.values(PagePermissions),
    'Component Access': Object.values(ComponentPermissions),
    'Actions': Object.values(ActionPermissions),
};
// Comprehensive Permission metadata for better UX
export const PERMISSION_METADATA = {
    // Page Permissions - Public
    'page.home.view': { label: 'View Home Page', description: 'Access to public home page', category: 'Public Pages', riskLevel: 'low' },
    'page.welcome.view': { label: 'View Welcome Page', description: 'Access to welcome page', category: 'Public Pages', riskLevel: 'low' },
    'page.contact.view': { label: 'View Contact Page', description: 'Access to contact information', category: 'Public Pages', riskLevel: 'low' },
    'page.login.view': { label: 'View Login Page', description: 'Access to login interface', category: 'Public Pages', riskLevel: 'low' },
    'page.register.view': { label: 'View Registration Page', description: 'Access to registration form', category: 'Public Pages', riskLevel: 'low' },
    // Page Permissions - Dealer
    'page.dealer.dashboard.view': { label: 'View Dealer Dashboard', description: 'Access to dealer control panel', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.dealer.profile.view': { label: 'View Dealer Profile', description: 'Access to profile information', category: 'Dealer Pages', riskLevel: 'low' },
    'page.dealer.profile.edit': { label: 'Edit Dealer Profile', description: 'Modify profile information', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.dealer.settings.view': { label: 'View Dealer Settings', description: 'Access to account settings', category: 'Dealer Pages', riskLevel: 'low' },
    'page.atelier.view': { label: 'View Atelier', description: 'Access to diamond search and atelier interface', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.inventory.search.view': { label: 'View Inventory Search', description: 'Access to inventory search tools', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.inventory.browse.view': { label: 'Browse Inventory', description: 'Browse available diamond inventory', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.inventory.details.view': { label: 'View Inventory Details', description: 'Access detailed diamond information', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.orders.view': { label: 'View Orders', description: 'Access to order management', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.orders.history.view': { label: 'View Order History', description: 'Access to past orders', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.orders.details.view': { label: 'View Order Details', description: 'Access detailed order information', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.orders.create': { label: 'Create Orders', description: 'Create new diamond orders', category: 'Dealer Pages', riskLevel: 'high' },
    'page.memo.requests.view': { label: 'View Memo Requests', description: 'Access to memo request system', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.memo.history.view': { label: 'View Memo History', description: 'Access to memo history', category: 'Dealer Pages', riskLevel: 'medium' },
    'page.memo.requests.manage': { label: 'Manage Memo Requests', description: 'Approve/reject memo requests', category: 'Dealer Pages', riskLevel: 'high' },
    // Page Permissions - Admin
    'page.admin.dashboard.view': { label: 'View Admin Dashboard', description: 'Access to admin control panel', category: 'Admin Pages', riskLevel: 'high' },
    'page.admin.users.view': { label: 'View User Management', description: 'Access to user management admin panel', category: 'Admin Pages', riskLevel: 'high' },
    'page.admin.inventory.view': { label: 'View Inventory Management', description: 'Access to inventory administration', category: 'Admin Pages', riskLevel: 'high' },
    'page.admin.analytics.view': { label: 'View Analytics', description: 'Access to business analytics and reports', category: 'Admin Pages', riskLevel: 'high' },
    'page.admin.settings.view': { label: 'View System Settings', description: 'Access to system configuration', category: 'Admin Pages', riskLevel: 'critical' },
    'page.admin.permissions.view': { label: 'View Permission Management', description: 'Access to permission administration', category: 'Admin Pages', riskLevel: 'critical' },
    'page.admin.audit.view': { label: 'View Audit Logs', description: 'Access to system audit trails', category: 'Admin Pages', riskLevel: 'critical' },
    // Component Permissions - Navigation
    'component.navigation.dealer_menu': { label: 'Dealer Menu', description: 'Show dealer navigation menu', category: 'Navigation', riskLevel: 'low' },
    'component.navigation.admin_menu': { label: 'Admin Menu', description: 'Show admin navigation menu', category: 'Navigation', riskLevel: 'medium' },
    'component.navigation.super_admin_menu': { label: 'Super Admin Menu', description: 'Show super admin navigation', category: 'Navigation', riskLevel: 'high' },
    // Component Permissions - Search
    'component.search.basic': { label: 'Basic Search', description: 'Use basic diamond search', category: 'Search Tools', riskLevel: 'low' },
    'component.search.advanced': { label: 'Advanced Search', description: 'Use advanced search filters', category: 'Search Tools', riskLevel: 'medium' },
    'component.search.ai_powered': { label: 'AI-Powered Search', description: 'Use AI-powered search capabilities', category: 'Search Tools', riskLevel: 'medium' },
    'component.search.saved_searches': { label: 'Saved Searches', description: 'Save and manage search queries', category: 'Search Tools', riskLevel: 'low' },
    // Component Permissions - Inventory
    'component.inventory.basic.view': { label: 'Basic Inventory View', description: 'View basic diamond inventory', category: 'Inventory Access', riskLevel: 'low' },
    'component.inventory.premium.view': { label: 'Advanced Inventory View', description: 'View advanced diamond inventory features', category: 'Inventory Access', riskLevel: 'medium' },
    'component.inventory.exclusive.view': { label: 'Exclusive Inventory View', description: 'View exclusive diamond inventory', category: 'Inventory Access', riskLevel: 'high' },
    'component.inventory.prices.view': { label: 'View Diamond Prices', description: 'See diamond pricing information', category: 'Inventory Access', riskLevel: 'medium' },
    'component.inventory.wholesale_prices.view': { label: 'View Wholesale Prices', description: 'See wholesale pricing information', category: 'Inventory Access', riskLevel: 'high' },
    'component.inventory.dealer_prices.view': { label: 'View Dealer Prices', description: 'See special dealer pricing', category: 'Inventory Access', riskLevel: 'high' },
    // Component Permissions - Export
    'component.export.search_results': { label: 'Export Search Results', description: 'Export diamond search results', category: 'Export Tools', riskLevel: 'medium' },
    'component.export.inventory_list': { label: 'Export Inventory List', description: 'Export inventory data', category: 'Export Tools', riskLevel: 'medium' },
    'component.export.order_data': { label: 'Export Order Data', description: 'Export order information', category: 'Export Tools', riskLevel: 'high' },
    'component.export.user_data': { label: 'Export User Data', description: 'Export user information and analytics', category: 'Export Tools', riskLevel: 'critical' },
    // Component Permissions - Memo
    'component.memo.request': { label: 'Request Memo', description: 'Request diamond memo/hold', category: 'Memo System', riskLevel: 'medium' },
    'component.memo.approve': { label: 'Approve Memo', description: 'Approve memo requests', category: 'Memo System', riskLevel: 'high' },
    'component.memo.status.view': { label: 'View Memo Status', description: 'Check memo request status', category: 'Memo System', riskLevel: 'low' },
    'component.memo.limits.manage': { label: 'Manage Memo Limits', description: 'Set memo credit limits', category: 'Memo System', riskLevel: 'critical' },
    // Component Permissions - User Management
    'component.users.list.view': { label: 'View User List', description: 'See list of system users', category: 'User Management', riskLevel: 'high' },
    'component.users.details.view': { label: 'View User Details', description: 'See detailed user information', category: 'User Management', riskLevel: 'high' },
    'component.users.roles.edit': { label: 'Edit User Roles', description: 'Modify user role assignments', category: 'User Management', riskLevel: 'critical' },
    'component.users.permissions.edit': { label: 'Edit User Permissions', description: 'Modify individual user permissions', category: 'User Management', riskLevel: 'critical' },
    'component.users.audit.view': { label: 'View User Audit Log', description: 'See user activity history', category: 'User Management', riskLevel: 'high' },
    // Action Permissions - Authentication
    'action.auth.login': { label: 'Login', description: 'Authenticate to the system', category: 'Authentication', riskLevel: 'low' },
    'action.auth.logout': { label: 'Logout', description: 'End user session', category: 'Authentication', riskLevel: 'low' },
    'action.auth.register': { label: 'Register Account', description: 'Create new user account', category: 'Authentication', riskLevel: 'medium' },
    'action.auth.password_reset': { label: 'Reset Password', description: 'Reset user password', category: 'Authentication', riskLevel: 'medium' },
    // Action Permissions - Profile
    'action.user.profile.update': { label: 'Update Profile', description: 'Modify user profile information', category: 'Profile Management', riskLevel: 'low' },
    'action.user.password.change': { label: 'Change Password', description: 'Change user password', category: 'Profile Management', riskLevel: 'medium' },
    'action.user.mfa.enable': { label: 'Enable MFA', description: 'Enable multi-factor authentication', category: 'Profile Management', riskLevel: 'medium' },
    'action.user.mfa.disable': { label: 'Disable MFA', description: 'Disable multi-factor authentication', category: 'Profile Management', riskLevel: 'high' },
    'action.user.preferences.update': { label: 'Update Preferences', description: 'Modify user preferences', category: 'Profile Management', riskLevel: 'low' },
    // Action Permissions - Diamond Actions
    'action.diamond.details.view': { label: 'View Diamond Details', description: 'See detailed diamond information', category: 'Diamond Actions', riskLevel: 'low' },
    'action.diamond.certificate.view': { label: 'View Diamond Certificate', description: 'Access diamond certification', category: 'Diamond Actions', riskLevel: 'medium' },
    'action.diamond.images.download': { label: 'Download Diamond Images', description: 'Download high-resolution images', category: 'Diamond Actions', riskLevel: 'medium' },
    // Action Permissions - Transactions
    'action.transaction.memo.request': { label: 'Request Memo', description: 'Request diamond memo/hold', category: 'Transaction Actions', riskLevel: 'medium' },
    'action.transaction.memo.approve': { label: 'Approve Memo', description: 'Approve memo requests', category: 'Transaction Actions', riskLevel: 'high' },
    'action.transaction.memo.reject': { label: 'Reject Memo', description: 'Reject memo requests', category: 'Transaction Actions', riskLevel: 'high' },
    'action.transaction.purchase': { label: 'Purchase Diamonds', description: 'Complete diamond purchase transactions', category: 'Transaction Actions', riskLevel: 'high' },
    'action.transaction.reserve': { label: 'Reserve Diamonds', description: 'Reserve diamonds for future purchase', category: 'Transaction Actions', riskLevel: 'medium' },
    'action.transaction.reservation.cancel': { label: 'Cancel Reservations', description: 'Cancel diamond reservations', category: 'Transaction Actions', riskLevel: 'medium' },
    // Action Permissions - Orders
    'action.order.create': { label: 'Create Orders', description: 'Create new diamond orders', category: 'Order Management', riskLevel: 'high' },
    'action.order.modify': { label: 'Modify Orders', description: 'Modify existing orders', category: 'Order Management', riskLevel: 'high' },
    'action.order.cancel': { label: 'Cancel Orders', description: 'Cancel diamond orders', category: 'Order Management', riskLevel: 'high' },
    'action.order.approve': { label: 'Approve Orders', description: 'Approve diamond orders', category: 'Order Management', riskLevel: 'high' },
    'action.order.fulfill': { label: 'Fulfill Orders', description: 'Mark orders as fulfilled', category: 'Order Management', riskLevel: 'high' },
    'action.order.payment.process': { label: 'Process Payments', description: 'Process order payments', category: 'Order Management', riskLevel: 'critical' },
    // Action Permissions - Export
    'action.export.search_results': { label: 'Export Search Results', description: 'Export diamond search results', category: 'Data Export', riskLevel: 'medium' },
    'action.export.order_history': { label: 'Export Order History', description: 'Export order data', category: 'Data Export', riskLevel: 'high' },
    'action.export.memo_history': { label: 'Export Memo History', description: 'Export memo data', category: 'Data Export', riskLevel: 'medium' },
    'action.export.user_data': { label: 'Export User Data', description: 'Export user information and analytics', category: 'Data Export', riskLevel: 'critical' },
    'action.export.analytics': { label: 'Export Analytics', description: 'Export business analytics data', category: 'Data Export', riskLevel: 'critical' },
    // Action Permissions - Admin User Management
    'action.admin.user.create': { label: 'Create Users', description: 'Create new user accounts', category: 'Admin - User Management', riskLevel: 'high' },
    'action.admin.user.edit': { label: 'Edit Users', description: 'Modify user account information', category: 'Admin - User Management', riskLevel: 'high' },
    'action.admin.user.delete': { label: 'Delete Users', description: 'Permanently delete user accounts', category: 'Admin - User Management', riskLevel: 'critical' },
    'action.admin.user.role.update': { label: 'Update User Roles', description: 'Change user role assignments', category: 'Admin - User Management', riskLevel: 'critical' },
    'action.admin.user.status.update': { label: 'Update User Status', description: 'Change user account status', category: 'Admin - User Management', riskLevel: 'high' },
    'action.admin.user.password.reset': { label: 'Reset User Passwords', description: 'Reset user passwords', category: 'Admin - User Management', riskLevel: 'high' },
    'action.admin.user.account.unlock': { label: 'Unlock User Accounts', description: 'Unlock locked user accounts', category: 'Admin - User Management', riskLevel: 'high' },
    // Action Permissions - Admin Permissions
    'action.admin.permissions.user.view': { label: 'View User Permissions', description: 'See user permission details', category: 'Admin - Permissions', riskLevel: 'high' },
    'action.admin.permissions.user.edit': { label: 'Edit User Permissions', description: 'Modify individual user permissions', category: 'Admin - Permissions', riskLevel: 'critical' },
    'action.admin.permissions.template.create': { label: 'Create Permission Templates', description: 'Create reusable permission templates', category: 'Admin - Permissions', riskLevel: 'high' },
    'action.admin.permissions.role.manage': { label: 'Manage Role Permissions', description: 'Modify role-based permissions', category: 'Admin - Permissions', riskLevel: 'critical' },
    'action.admin.permissions.audit.view': { label: 'View Permission Audits', description: 'Access permission change history', category: 'Admin - Permissions', riskLevel: 'high' },
    // Action Permissions - Admin Inventory
    'action.admin.inventory.add': { label: 'Add Inventory', description: 'Add new diamonds to inventory', category: 'Admin - Inventory', riskLevel: 'high' },
    'action.admin.inventory.edit': { label: 'Edit Inventory', description: 'Modify diamond inventory data', category: 'Admin - Inventory', riskLevel: 'high' },
    'action.admin.inventory.delete': { label: 'Delete Inventory', description: 'Remove diamonds from inventory', category: 'Admin - Inventory', riskLevel: 'critical' },
    'action.admin.inventory.bulk_update': { label: 'Bulk Update Inventory', description: 'Update multiple inventory items', category: 'Admin - Inventory', riskLevel: 'critical' },
    'action.admin.inventory.pricing.update': { label: 'Update Inventory Pricing', description: 'Modify diamond pricing', category: 'Admin - Inventory', riskLevel: 'critical' },
    'action.admin.inventory.categories.manage': { label: 'Manage Inventory Categories', description: 'Manage inventory categorization', category: 'Admin - Inventory', riskLevel: 'high' },
    // Action Permissions - System Admin
    'action.admin.system.configure': { label: 'System Configuration', description: 'Configure system settings', category: 'System Administration', riskLevel: 'critical' },
    'action.admin.system.integrations.manage': { label: 'Manage Integrations', description: 'Manage third-party integrations', category: 'System Administration', riskLevel: 'critical' },
    'action.admin.system.logs.view': { label: 'View System Logs', description: 'Access system log files', category: 'System Administration', riskLevel: 'high' },
    'action.admin.system.backup': { label: 'System Backup', description: 'Create system backups', category: 'System Administration', riskLevel: 'critical' },
    'action.admin.system.restore': { label: 'System Restore', description: 'Restore system from backup', category: 'System Administration', riskLevel: 'critical' },
    // Page Permissions - Auction House
    'page.auction.house.view': { label: 'View Auction House', description: 'Access auction house listings', category: 'Auction House', riskLevel: 'medium' },
    'page.auction.detail.view': { label: 'View Auction Details', description: 'See auction details and bid history', category: 'Auction House', riskLevel: 'medium' },
    'page.auction.admin.view': { label: 'Auction Admin Panel', description: 'Access auction management dashboard', category: 'Auction House', riskLevel: 'high' },
    // Component Permissions - Auction House
    'component.auction.active.view': { label: 'View Active Auctions', description: 'See active auction listings', category: 'Auction House', riskLevel: 'medium' },
    'component.auction.history.view': { label: 'View Auction History', description: 'See past auction results', category: 'Auction House', riskLevel: 'medium' },
    'component.auction.bid.place': { label: 'Place Auction Bids', description: 'Place bids in active auctions', category: 'Auction House', riskLevel: 'high' },
    'component.auction.create': { label: 'Create Auctions', description: 'Access auction creation interface', category: 'Auction House', riskLevel: 'critical' },
    'component.auction.manage': { label: 'Manage Auctions', description: 'Manage active and scheduled auctions', category: 'Auction House', riskLevel: 'critical' },
    'component.auction.analytics.view': { label: 'Auction Analytics', description: 'View auction performance analytics', category: 'Auction House', riskLevel: 'high' },
    // Action Permissions - Auction House
    'action.auction.create': { label: 'Create Auctions', description: 'Create new diamond auctions', category: 'Auction House', riskLevel: 'critical' },
    'action.auction.edit': { label: 'Edit Auctions', description: 'Modify auction settings before start', category: 'Auction House', riskLevel: 'critical' },
    'action.auction.cancel': { label: 'Cancel Auctions', description: 'Cancel active or scheduled auctions', category: 'Auction House', riskLevel: 'critical' },
    'action.auction.bid.place': { label: 'Place Bids', description: 'Submit bids on diamond auctions', category: 'Auction House', riskLevel: 'high' },
    'action.auction.supervised.control': { label: 'Control Supervised Auction', description: 'Manage live supervised auction flow', category: 'Auction House', riskLevel: 'critical' },
    'action.auction.close': { label: 'Close Auctions', description: 'Manually close an auction', category: 'Auction House', riskLevel: 'critical' },
    'action.auction.invite': { label: 'Invite to Auction', description: 'Invite dealers to private auctions', category: 'Auction House', riskLevel: 'high' },
    // Action Permissions - Super Admin
    'action.super_admin.users.manage': { label: 'Manage Admin Users', description: 'Manage administrator accounts', category: 'Super Admin Actions', riskLevel: 'critical' },
    'action.super_admin.roles.configure': { label: 'Configure Roles', description: 'Define and modify user roles', category: 'Super Admin Actions', riskLevel: 'critical' },
    'action.super_admin.system.maintenance': { label: 'System Maintenance', description: 'Perform system maintenance operations', category: 'Super Admin Actions', riskLevel: 'critical' },
    'action.super_admin.database.raw_access': { label: 'Raw Database Access', description: 'Direct database access and queries', category: 'Super Admin Actions', riskLevel: 'critical' },
    'action.super_admin.emergency.override': { label: 'Emergency Override', description: 'Override all system restrictions in emergencies', category: 'Super Admin Actions', riskLevel: 'critical' },
};
// Real-world permission mappings that match the UI structure
export const getPermissionsByCategory = () => {
    const pagePermissions = Object.values(PagePermissions);
    const componentPermissions = Object.values(ComponentPermissions);
    const actionPermissions = Object.values(ActionPermissions);
    return {
        'Page Access': pagePermissions.map(p => ({
            permission: p,
            label: p.split('.').pop()?.replace(/_/g, ' ') || p,
            description: PERMISSION_METADATA[p]?.description || 'No description',
            category: 'Pages',
            riskLevel: PERMISSION_METADATA[p]?.riskLevel || 'low'
        })),
        'Component Access': componentPermissions.map(p => ({
            permission: p,
            label: p.split('.').pop()?.replace(/_/g, ' ') || p,
            description: PERMISSION_METADATA[p]?.description || 'No description',
            category: 'Components',
            riskLevel: PERMISSION_METADATA[p]?.riskLevel || 'low'
        })),
        'Actions': actionPermissions.map(p => ({
            permission: p,
            label: p.split('.').pop()?.replace(/_/g, ' ') || p,
            description: PERMISSION_METADATA[p]?.description || 'No description',
            category: 'Actions',
            riskLevel: PERMISSION_METADATA[p]?.riskLevel || 'low'
        }))
    };
};
// Helper function to get inherited permissions for a role
export const getInheritedPermissions = (roleLevel) => {
    const permissions = [];
    // Inherit from all lower roles
    for (let level = RoleLevel.GUEST; level <= roleLevel; level++) {
        if (ENHANCED_ROLE_PERMISSIONS[level]) {
            permissions.push(...ENHANCED_ROLE_PERMISSIONS[level]);
        }
    }
    return [...new Set(permissions)]; // Remove duplicates
};
